type ValidationRule = {
  field: string;
  label: string;
  required?: boolean;
  custom?: (value: any, data: any) => string | null;
};

export const validate = (data: any, rules: ValidationRule[]) => {
  const errors: Record<string, string> = {};

  rules.forEach((rule) => {
    const value = data[rule.field];

    // Required check
    if (rule.required) {
      if (
        value === undefined ||
        value === null ||
        value === "" ||
        (value instanceof File && !value.name) || // for file
        (Array.isArray(value) && value.length === 0)
      ) {
        errors[rule.field] = `${rule.label} is required`;
        return;
      }
    }

    // Custom validation
    if (rule.custom) {
      const error = rule.custom(value, data);
      if (error) {
        errors[rule.field] = error;
      }
    }
  });

  return errors;
};
